export const messages = {
  en: {
    activitiesManage: {
      search: {
        title: 'Search Conditions',
        activitiesId: 'Please enter activity ID',
        titlePlaceholder: 'Please enter title',
        typeCd: 'Please select activity type',
        staffName: 'Please enter publisher name'
      },
      list: {
        title: 'Activity List'
      },
      table: {
        activitiesId: 'Activity ID',
        title: 'Title',
        typeCd: 'Type',
        startTime: 'Start Time',
        endTime: 'End Time',
        userName: 'Publisher'
      },
      add: {
        title: 'Add Activity',
        titlePlaceholder: 'Required, please enter title',
        typeCd: 'Activity Type',
        startTime: 'start time',
        endTime: 'end time',
        typeCdPlaceholder: 'Required, please select type',
        isMoreCommunity: 'Multi-community',
        isMoreCommunityPlaceholder: 'Please select if multi-community',
        headerImg: 'Header Image (800*595)',
        startTimePlaceholder: 'Required, please enter start time',
        endTimePlaceholder: 'Required, please enter end time',
        address: 'Address',
        addressPlaceholder: 'Please enter address',
        context: 'Content',
        isSignup: 'Allow Signup',
        isSignupPlaceholder: 'Please select if allow signup',
        signupStartTime: 'Signup Start Time',
        signupStartTimePlaceholder: 'Required, please enter signup start time',
        signupEndTime: 'Signup End Time',
        signupEndTimePlaceholder: 'Required, please enter signup end time',
        signupLimit: 'Signup Limit',
        signupLimitPlaceholder: 'Required, please enter signup limit'
      },
      edit: {
        title: 'Edit Activity',
        titlePlaceholder: 'Required, please enter title',
        typeCd: 'Activity Type',
        startTime: 'start time',
        endTime: 'end time',
        typeCdPlaceholder: 'Required, please select type',
        headerImg: 'Header Image (800*595)',
        startTimePlaceholder: 'Required, please enter start time',
        endTimePlaceholder: 'Required, please enter end time',
        address: 'Address',
        addressPlaceholder: 'Please enter address',
        context: 'Content',
        isSignup: 'Allow Signup',
        isSignupPlaceholder: 'Please select if allow signup',
        signupStartTime: 'Signup Start Time',
        signupStartTimePlaceholder: 'Required, please enter signup start time',
        signupEndTime: 'Signup End Time',
        signupEndTimePlaceholder: 'Required, please enter signup end time',
        signupLimit: 'Signup Limit',
        signupLimitPlaceholder: 'Required, please enter signup limit'
      },
      delete: {
        title: 'Confirm Operation',
        confirmText: 'Are you sure to delete this activity?'
      },
      validate: {
        titleRequired: 'Title is required',
        titleMaxLength: 'Title cannot exceed 200 characters',
        typeCdRequired: 'Type is required',
        headerImgRequired: 'Header image is required',
        contextRequired: 'Content is required',
        startTimeRequired: 'Start time is required',
        endTimeRequired: 'End time is required',
        activitiesIdRequired: 'Activity ID is required',
        imageSize: 'Image size cannot exceed 2MB',
        isSignupRequired: 'Allow signup is required',
        signupStartTimeRequired: 'Signup start time is required',
        signupEndTimeRequired: 'Signup end time is required',
        signupLimitRequired: 'Signup limit is required',
        signupLimitMin: 'Signup limit must be at least 1'
      }
    }
  },
  zh: {
    activitiesManage: {
      search: {
        title: '查询条件',
        activitiesId: '请输入活动ID',
        titlePlaceholder: '请输入标题',
        typeCd: '请选择活动类型',
        staffName: '请输入发布人名称'
      },
      list: {
        title: '活动列表'
      },
      table: {
        activitiesId: '活动ID',
        title: '标题',
        typeCd: '类型',
        startTime: '开始时间',
        endTime: '结束时间',
        userName: '发布人'
      },
      add: {
        title: '添加活动',
        titlePlaceholder: '必填，请输入标题',
        typeCd: '类型',
        startTime: '开始时间',
        endTime: '结束时间',
        typeCdPlaceholder: '必填，请选择类型',
        isMoreCommunity: '多小区',
        isMoreCommunityPlaceholder: '请选择是否多小区',
        headerImg: '头部照片(800*595)',
        startTimePlaceholder: '必填，请输入开始时间',
        endTimePlaceholder: '必填，请输入结束时间',
        address: '活动地址',
        addressPlaceholder: '请输入活动地址',
        context: '内容',
        isSignup: '是否可报名',
        isSignupPlaceholder: '请选择是否可报名',
        signupStartTime: '报名开始时间',
        signupStartTimePlaceholder: '必填，请输入报名开始时间',
        signupEndTime: '报名结束时间',
        signupEndTimePlaceholder: '必填，请输入报名结束时间',
        signupLimit: '报名人数限制',
        signupLimitPlaceholder: '必填，请输入报名人数限制'
      },
      edit: {
        title: '编辑活动',
        titlePlaceholder: '必填，请输入标题',
        typeCd: '类型',
        typeCdPlaceholder: '必填，请选择类型',
        headerImg: '头部照片(800*595)',
        startTimePlaceholder: '必填，请输入开始时间',
        endTimePlaceholder: '必填，请输入结束时间',
        address: '活动地址',
        addressPlaceholder: '请输入活动地址',
        startTime: '开始时间',
        endTime: '结束时间',
        context: '内容',
        isSignup: '是否可报名',
        isSignupPlaceholder: '请选择是否可报名',
        signupStartTime: '报名开始时间',
        signupStartTimePlaceholder: '必填，请输入报名开始时间',
        signupEndTime: '报名结束时间',
        signupEndTimePlaceholder: '必填，请输入报名结束时间',
        signupLimit: '报名人数限制',
        signupLimitPlaceholder: '必填，请输入报名人数限制'
      },
      delete: {
        title: '确认操作',
        confirmText: '确认删除该活动吗？'
      },
      validate: {
        titleRequired: '请输入活动标题',
        titleMaxLength: '活动标题不能超过200个字符',
        typeCdRequired: '请选择活动类型',
        headerImgRequired: '请上传活动封面图片',
        contextRequired: '请输入活动内容',
        startTimeRequired: '请选择活动开始时间',
        endTimeRequired: '请选择活动结束时间',
        activitiesIdRequired: '活动ID不能为空',
        isSignupRequired: '请选择是否需要报名',
        signupStartTimeRequired: '请选择报名开始时间',
        signupEndTimeRequired: '请选择报名结束时间',
        signupLimitRequired: '请输入报名限制人数',
        signupLimitMin: '报名限制人数不能小于1'
      },
      operation: {
        viewSignup: '查看报名'
      },
      signup: {
        title: '活动报名管理',
        listTitle: '报名人员列表',
        table: {
          signupId: '报名ID',
          name: '姓名',
          phone: '手机号',
          roomNum: '房号',
          signupTime: '报名时间',
          statusCd: '状态'
        },
        form: {
          name: '姓名',
          namePlaceholder: '请输入姓名',
          phone: '手机号',
          phonePlaceholder: '请输入手机号',
          roomNum: '房号',
          roomNumPlaceholder: '请输入房号',
          statusCd: '状态',
          statusCdPlaceholder: '请选择状态'
        },
        status: {
          normal: '正常',
          cancel: '取消'
        },
        validate: {
          nameRequired: '请输入姓名',
          phoneRequired: '请输入手机号',
          phonePattern: '请输入正确的手机号',
          roomNumRequired: '请输入房号',
          statusCdRequired: '请选择状态'
        },
        deleteConfirm: '确定要删除这条报名记录吗？'
      }
    }
  }
}